var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('div',{style:('width:100%;height: ' +
            _vm.height +
            '; background-color: #c5e8ff;padding:0px;margin:0px;'),attrs:{"id":_vm._uid + '_map'}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"pop_up"},[_vm._v(" "+_vm._s(_vm.selected_index)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }